import { render, staticRenderFns } from "./price-detail.vue?vue&type=template&id=bcaf119e&scoped=true"
import script from "./price-detail.vue?vue&type=script&lang=js"
export * from "./price-detail.vue?vue&type=script&lang=js"
import style0 from "./price-detail.vue?vue&type=style&index=0&id=bcaf119e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcaf119e",
  null
  
)

export default component.exports